import { render, staticRenderFns } from "./EfsMarginLedgerModal__Style#Drawer.vue?vue&type=template&id=2f053fe6&scoped=true&"
import script from "./EfsMarginLedgerModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./EfsMarginLedgerModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./EfsMarginLedgerModal__Style#Drawer.vue?vue&type=style&index=0&id=2f053fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f053fe6",
  null
  
)

export default component.exports